module.exports = __webpack_public_path__ + "img/side-placeholder.0dee8f5d.svg";